import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ppob-ilustration-2.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-right flex" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "self-end w-full",
    src: _imports_0,
    alt: "ppob"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PPOBPopupModal = _resolveComponent("PPOBPopupModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePPOBDialog(true))),
      class: "mt-2 w-full bg-white rounded relative cursor-pointer overflow-hidden"
    }, [
      _hoisted_1
    ]),
    (_ctx.ppobDialogModelValue)
      ? (_openBlock(), _createBlock(_component_PPOBPopupModal, {
          key: 0,
          modelValue: _ctx.ppobDialogModelValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ppobDialogModelValue = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}